import { statistics } from '../api'
const defaultData = function () {
  let now = new Date()
  let env = getEnvInfo()
  let params = {
    // 语言
    language: window.navigator.language,
    // 来源
    referrer: document.referrer || 'null',
    // 当前页标题
    title: document.title || 'null',
    // 当前链接
    url: document.URL,
    // 域名
    domain: document.domain
  }

  let args = ''
  for (let i in params) {
    if (args !== '') {
      args += '&'
    }
    args += `${i}=${params[i]}`
  }
  let type = 1
  if (env === 0 || env === 1) {
    type = 1
  } else {
    type = 2
  }
  return {
    type: type,
    reserve: args,
    platform: env,
    timezone: now.getTimezoneOffset() / 60,
    app: 'shecare',
    year: now.getFullYear(),
    month: now.getMonth() + 1,
    day: now.getDate(),
    createTime: parseInt(now.getTime() / 1000)
  }
}


const getEnvInfo = function () {
  const ua = navigator.userAgent.toLowerCase()
  const p = navigator.platform

  let system = 'Unknown Device'

  if (ua.indexOf('micromessenger') !== -1) {
    system = 2
  } else if (ua.indexOf('android') > -1) {
    system = 0
  } else if (p.indexOf('iP') === 0) {
    system = 1
  } else if (window.__wxjs_environment === 'miniprogram') {
    system = 3
  } else {
    system = 4
  }
  return system
}

const shecareTrack = function (value, event, reserved) {
  track(value, event, reserved)
}

const track = function (value, event, reserved) {
  let params = defaultData()
  if (!reserved) {
    reserved = ''
  }
  params.reserved=reserved
  let url = `?value=${value || ''}&type=${params.type}`
  statistics(url, {
    ...params, event: event
  })
}

/**
 * 
 * @param {url s参数} query 
 * @returns url path+s参数
 */
const getTrackEventTag = function (query) {
  let urlHash = location.hash
  let startIndex = urlHash.lastIndexOf('/')
  let endIndex = urlHash.lastIndexOf('?')
  if (endIndex === -1) {
    endIndex = urlHash.length
  }
  let trackEventTag = urlHash.slice(startIndex + 1, endIndex)
  let s = query && query.s || ''
  if (s) {
    trackEventTag = trackEventTag + '_' + s
  }
  return trackEventTag.toUpperCase()
}

/**
 * 
 * @param {url s参数} query 
 * @returns url path或者s参数
 */
const getUrlTrackEventTag = function (query) {
  let urlHash = location.hash
  let startIndex = urlHash.lastIndexOf('/')
  let endIndex = urlHash.lastIndexOf('?')
  if (endIndex === -1) {
    endIndex = urlHash.length
  }
  let trackEventTag = urlHash.slice(startIndex + 1, endIndex)
  let s = query && query.s || ''
  if (s) {
    trackEventTag = s
  }
  return trackEventTag.toUpperCase()
}

export default {
  track: track,
  getTrackEventTag: getTrackEventTag,
  getUrlTrackEventTag: getUrlTrackEventTag,
  shecareTrack: shecareTrack
}